import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "validador-card"
}
const _hoisted_2 = {
  key: 1,
  class: "validador-card"
}
const _hoisted_3 = { class: "validador-titulo" }
const _hoisted_4 = { class: "validador-nome" }
const _hoisted_5 = { class: "validador-mensagem" }
const _hoisted_6 = {
  key: 2,
  class: "validador-card"
}
const _hoisted_7 = { class: "validador-mensagem" }

import { onMounted, reactive } from "vue";
import { useRoute } from "vue-router";

import * as service from "@/services/clientesService";


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {


const route = useRoute();

const controle = reactive({
  carregando: true,
  encontrado: false,
  nome: "",
  ativo: false,
  erro: "",
});

onMounted(() => {
  const id = Number(route.params.id);

  service.validarCartao(id)
    .then(r => {
      controle.encontrado = true;
      controle.nome = r.nome;
      controle.ativo = r.ativo;
    })
    .catch(() => {
      controle.erro = "Cliente não encontrado.";
    })
    .finally(() => {
      controle.carregando = false;
    });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["validador-container", {
    'bg-ativo': !controle.carregando && controle.encontrado && controle.ativo,
    'bg-inativo': !controle.carregando && (!controle.encontrado || !controle.ativo)
  }])
  }, [
    (controle.carregando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", {
            class: "spinner-border text-secondary",
            role: "status"
          }, null, -1),
          _createElementVNode("div", { class: "mt-3" }, "Verificando...", -1)
        ]))]))
      : (controle.encontrado)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(controle.ativo ? 'Cliente Ativo' : 'Cliente Inativo'), 1),
            _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "validador-linha" }, null, -1)),
            _createElementVNode("div", _hoisted_4, _toDisplayString(controle.nome), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(controle.ativo
          ? 'Cliente está com seu cadastro ativo em nosso sistema.'
          : 'Cliente está com seu cadastro inativo em nosso sistema.'), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "validador-titulo" }, "Não Encontrado", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "validador-linha" }, null, -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString(controle.erro), 1)
          ]))
  ], 2))
}
}

})